export const roleList = [
    {
        name: 'aggregator',
        label: 'Aggregator',
        popupTitle: 'Add Aggregator',
        props: {
            input: false,
            data: [],
            label: 'Select Aggregator',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'AGGREGATOR',
    },
    {
        name: 'franchise',
        label: 'Franchise',
        popupTitle: 'Add Franchise',
        props: {
            input: false,
            data: [],
            label: 'Select Franchise',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'FRANCHISE',
    },
    {
        name: 'mle',
        label: 'MLE',
        popupTitle: 'Add MLE',
        props: {
            data: [],
            input: false,
            label: 'Select MLE',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'MLE',
    },
    {
        name: 'merchant',
        label: 'Merchant',
        popupTitle: 'Add Merchant',
        props: {
            data: [],
            input: false,
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'MERCHANT',
    },
];

export const initialStatusOptions = [
    {
        name: 'Active',
        value: 1,
    },
    {
        name: 'Inactive',
        value: 2,
    },
]
export const TURN_OVER_CATEGORIES={small : "Small", large: "Large"}
